module.exports = __webpack_public_path__ + "static/media/v13.9bc8257d.JPG";